import React from 'react';
import { string } from 'prop-types';

const TileHead = ({ title, icon, automationId = '' }) => {

  return (
    <div className="fulfillment__head" data-automation-id={automationId}>
      <div className={`u__center ${icon}`} />
      <div className="u__bold">{title}</div>
    </div>
  );
};
TileHead.propTypes = {
  title: string,
  icon: string,
  automationId: string,
};
TileHead.defaultProps = {
  title: '',
  icon: '',
  automationId: ''
};

export { TileHead };
